const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  );
};

export default isMobileDevice;
